import { render, staticRenderFns } from "./CustomerDropdownFilter.vue?vue&type=template&id=50925cd6&scoped=true"
import script from "./CustomerDropdownFilter.vue?vue&type=script&lang=js"
export * from "./CustomerDropdownFilter.vue?vue&type=script&lang=js"
import style0 from "./CustomerDropdownFilter.vue?vue&type=style&index=0&id=50925cd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50925cd6",
  null
  
)

export default component.exports